module.exports = "./images/07_big_sofortueberweisung.jpg";